export default "__VITE_ASSET__CqfkttJF__"